import React from 'react';

const Sun = props => (
  <svg viewBox="0 0 32 32" width="1em" height="1em" {...props}>
    <path d="M16 9c-3.859 0-7 3.141-7 7s3.141 7 7 7 7-3.141 7-7-3.141-7-7-7zm0 12c-2.762 0-5-2.238-5-5s2.238-5 5-5 5 2.238 5 5-2.238 5-5 5zm0-14a1 1 0 0 0 1-1V4a1 1 0 0 0-2 0v2a1 1 0 0 0 1 1zm0 18a1 1 0 0 0-1 1v2a1 1 0 0 0 2 0v-2a1 1 0 0 0-1-1zm7.777-15.365l1.414-1.414a.999.999 0 1 0-1.414-1.414l-1.414 1.414a.999.999 0 1 0 1.414 1.414zM8.223 22.365l-1.414 1.414a.999.999 0 1 0 1.414 1.414l1.414-1.414a.999.999 0 1 0-1.414-1.414zM7 16a1 1 0 0 0-1-1H4a1 1 0 0 0 0 2h2a1 1 0 0 0 1-1zm21-1h-2a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2zM8.221 9.635a.999.999 0 1 0 1.414-1.414L8.221 6.807a.999.999 0 1 0-1.414 1.414l1.414 1.414zm15.558 12.728a.999.999 0 1 0-1.414 1.414l1.414 1.414a.999.999 0 1 0 1.414-1.414l-1.414-1.414z" />
  </svg>
);

export default Sun;
